// External libraries
import gql from 'graphql-tag';
//internal modules
import {
  CART_FRAGMENT,
  COMPLETED_PAYMENT_INFO_FRAGMENT,
} from '@/lib/graphql/fragments';

export const APPROVE_ONBOARD_PAYMENT_MUTATION = gql`
  mutation ApproveOnboardPaymentMutation(
    $token: String!
    $instrumentId: String
    $isBillingAgreement: Boolean!
  ) {
    attemptSetStickyFi(token: $token, instrumentId: $instrumentId)
      @include(if: $isBillingAgreement) {
      buyer {
        userId
      }
    }
    approveGuestSignUpPayment(token: $token) {
      buyer {
        userId
        email {
          stringValue
        }
        name {
          fullName
        }
      }
      ...CartDonePage
      ...CompletedPaymentInfo
      fundingOptions {
        fundingInstrument {
          id
          lastDigits
          name
          nameDescription
          type
        }
      }
      merchant {
        name
        preferences {
          autoReturnToMerchant
          enablePaymentDataTransfer
          returnUrl
        }
      }
      shippingAddresses {
        fullAddress
        name {
          fullName
        }
      }
    }
  }
  ${CART_FRAGMENT}
  ${COMPLETED_PAYMENT_INFO_FRAGMENT}
`;
